import { accountInitialValue } from "@/types/app/accounts";

export default {  
  modalAccount: false,
  modalNewAccount: false,
  modalAccountGrouping: false,
  modalCloneAccount: false,
  accountSent: false,
  account: accountInitialValue,
  accounts: [],
};
